import axios from 'axios'
import setting from '@/setting'
import store from '@/store'
import qs from 'qs'
import router from '@/router'

export class EcSiteApiService {
  constructor (config) {
    this.config = config
    return this.createAxiosInstance()
  }
  interceptorRequestConfig (config) {
    const accessToken = store.getters['auth/accessToken']
    if (accessToken && accessToken !== '') {
      // アクセストークンをセットする
      config.headers['Authorization'] = `Bearer ${accessToken}`
    }
    return config
  }
  interceptorRequestError (error) {
    return Promise.reject(error)
  }
  interceptorResponseConfig (response) {
    return response
  }
  async interceptorResponseError (error) {
    // ログイン前のAPIなのでリフレッシュトークン関連はせずにエラーハンドリング
    return this.responseErrorHandling(error)
  }
  createAxiosInstance () {
    const axiosInstance = axios.create(this.config)
    axiosInstance.interceptors.request.use(
      this.interceptorRequestConfig.bind(this),
      this.interceptorRequestError.bind(this)
    )
    axiosInstance.interceptors.response.use(
      this.interceptorResponseConfig.bind(this),
      this.interceptorResponseError.bind(this)
    )
    return {
      get (url, config = {}) {
        if ('params' in config) {
          config.paramsSerializer = (params) => {
            return qs.stringify(params, { arrayFormat: 'repeat' })
          }
        }
        return axiosInstance.get(`${url}`, config)
      },
      delete (url, config = {}) {
        return axiosInstance.delete(url, config)
      },
      post (url, data, config = {}) {
        return axiosInstance.post(`${url}`, data, config)
      },
      put (url, data, config = {}) {
        return axiosInstance.put(`${url}`, data, config)
      },
      patch (url, data, config = {}) {
        return axiosInstance.patch(`${url}`, data, config)
      }
    }
  }
  async responseErrorHandling (error) {
    const {config, response: {status}} = error

    // 500系 (Internal Server Error)
    if (status !== 503 && status >= 500 && status <= 599) {
      // 500エラーページへ
      // ※ API(サーバー)が復旧するまでアクセス不能...
      router.push({name: 'Error500'}).catch(() => {})
      // 503エラー
    } else if (status === 503) {
      // メンテナンス画面に遷移
      router.push({name: 'Error503'}).catch(() => {})

    // 403エラー
    } else if (status === 403) {
      // vue.jsのconfig設定が間違っている場合... (再ビルド & 再リリースが必要です)
      throw new Error('request token is invalid.')

    // 401エラー
    } else if (status === 401) {
      try {
        // アクセストークンの再発行
        const response = await axios.post('/user/refresh', {}, config)
        if (response.status === 201) {
          await store.commit('auth/setAccessToken', response.data)

          // リトライ
          try {
            config.headers['Authorization'] = `Bearer ${store.getters['auth/accessToken']}`
            const retry = await axios.request(config)
            return Promise.resolve(retry)
          } catch (e) {
            // エラー (400 Bad Requestなど)
            return Promise.reject(e)
          }
        }

        await store.commit('auth/clearData')
        console.error('Refresh Api Error', response)
      } catch (e) {
        await store.commit('auth/clearData')
        console.error(e)
      }

      // リフレッシュできなければ、401エラーページ(ログインページ)へ
      router.push({name: 'Error401'}).catch(() => {})
    }

    // その他 (400 Bad Requestなど)
    return Promise.reject(error)
  }
}
export const EcSiteApiInterface = new EcSiteApiService({
  baseURL: `${setting.apiURL}`,
  headers: {
    'Content-Type': 'application/json',
    'X-Api-Request-Token': setting.requestToken
  },
  timeout: 30000
})



// WEBPACK FOOTER //
// ./src/config/axios.js